import { render, staticRenderFns } from "./ConvoFormReport.vue?vue&type=template&id=18736dcd&"
import script from "./ConvoFormReport.vue?vue&type=script&lang=js&"
export * from "./ConvoFormReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports